// extracted by mini-css-extract-plugin
module.exports = {"root":"range-input_root__38eon","input":"range-input_input__2vGQi"};